module.exports = __webpack_public_path__ + "r-v3/img/emoti-fall-love.57fb158d.svg";